import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { Loader } from '@calendly/ui/components/loader';
import { Group, Menu as BaseMenu } from '@calendly/ui/components/menu';
import { ControlUI } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import React, { useEffect, forwardRef } from 'react';
import SearchInput from 'components/core/search_input';
import { PillControl, Pills, OptionsContainer, Option } from 'features/filter_menu';
const containerCss = "c6jo9gd";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const styledFixedContainerCss = "s7nj36a";
const StyledFixedContainer = forwardRef((props, ref) => <FixedContainer ref={ref} {...props} className={classNames(styledFixedContainerCss, props.className)} />);
const menuCss = "mnnrkb4";
const Menu = forwardRef((props, ref) => <BaseMenu ref={ref} {...props} className={classNames(menuCss, props.className)} />);
const searchContainerCss = "s1g210og";
const SearchContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(searchContainerCss, props.className)} />;
});
const MenuContent = ({
  collection,
  isLoading,
  selectedItems,
  setSearchTerm,
  toggleSelected
}) => <>
    <SearchContainer>
      <SearchInput autoFocus placeholder={I18n.t('publisher.organization.reporting.search_placeholder')} onChange={setSearchTerm} />
    </SearchContainer>
    <Group>
      <OptionsContainer>
        {!isLoading && collection.map(item => {
        const isSelected = !!selectedItems.some(({
          id
        }) => item.id === id);
        return <Option item={item} key={item.id} onClick={toggleSelected} selected={isSelected} />;
      })}
      </OptionsContainer>
    </Group>
    {isLoading && <Loader />}
  </>;
export const SearchFacet = ({
  collection = [],
  disabled = false,
  isLoading = false,
  onSelect = () => {},
  selected = [],
  title = '',
  setSearchTerm
}) => {
  const [toggleDropdown, Dropdown, isOpen] = useDropdown();
  const selectedItems = selected;
  const Control = selectedItems.length > 0 ? PillControl : ControlUI;
  const label = React.isValidElement(title) ? title.props.children : title;
  const selectedPillItems = selectedItems?.length > 0 ? selectedItems : null;
  const addToSelected = item => {
    onSelect([...selectedItems, item]);
  };
  const removeFromSelected = item => {
    onSelect(selectedItems.filter(({
      id
    }) => id !== item.id));
  };
  const toggleSelected = item => {
    if (!selectedItems.some(({
      id
    }) => id === item.id)) {
      addToSelected(item);
    } else {
      removeFromSelected(item);
    }
  };
  useEffect(() => {
    if (!isOpen) {
      setSearchTerm('');
    }
    return () => {};
  }, [isOpen, setSearchTerm]);
  return <Container>
      {title && <BodyText color="muted" weight="bold" inline>{title}</BodyText>}
      <Control expanded={isOpen} onClick={toggleDropdown} disabled={disabled} aria-label={label} data-testid="filter-dropdown-trigger" aria-expanded={isOpen}>
        {selectedPillItems ? <Pills items={selectedPillItems} onClick={removeFromSelected} /> : <BodyText color="muted">{I18n.t('publisher.event_types.filters.select_placeholder')}</BodyText>}
      </Control>
      <Dropdown>
        <Menu data-component="filter-dropdown-menu">
          <MenuContent collection={collection} isLoading={isLoading} selectedItems={selectedItems} setSearchTerm={setSearchTerm} toggleSelected={toggleSelected} />
        </Menu>
      </Dropdown>
      {isOpen && <StyledFixedContainer fixedWhen />}
    </Container>;
};

require("./search_facet.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_facet.js");